import {
  GET_TECHNICALADVISER_FAIL,
  GET_TECHNICALADVISER_SUCCESS,
  GET_TECHNICALADVISERS_FAIL,
  GET_TECHNICALADVISERS_SUCCESS,
  ADD_TECHNICALADVISER_SUCCESS,
  ADD_TECHNICALADVISER_FAIL,
  UPDATE_TECHNICALADVISER_SUCCESS,
  UPDATE_TECHNICALADVISER_FAIL,
  DELETE_TECHNICALADVISER_SUCCESS,
  DELETE_TECHNICALADVISER_FAIL,  
  SET_STATE_TECHNICALADVISER,
  UPDATE_TECHNICALADVISER_CHECK
} from "./actionTypes";

const INIT_STATE = {
  technicalAdvisers: [],
  technicalAdviser: {},
  error: {},
  loading: false,
  total:0,
  currentPage:0,
};

const technicalAdvisers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_TECHNICALADVISERS_SUCCESS:
      return {
        ...state,
        // technicalAdvisers: action.payload.technicalAdvisers,
        technicalAdvisers: action.payload.technicalAdvisers.map(technicalAdviser => {
          return {...technicalAdviser, checked: false}
        }),
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_TECHNICALADVISER:
      return { ...state, loading: action.payload }

    case GET_TECHNICALADVISERS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_TECHNICALADVISER_SUCCESS:
      return {
        ...state,
        technicalAdvisers: [...state.technicalAdvisers, action.payload],
      };

    case ADD_TECHNICALADVISER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_TECHNICALADVISER_SUCCESS:
      return {
        ...state,
        technicalAdvisers: state.technicalAdvisers.map(technicalAdviser =>
          technicalAdviser.id.toString() === action.payload.id.toString()
            ? { ...action.payload, technicalAdviser }
            : technicalAdviser
        ),
      };

    case UPDATE_TECHNICALADVISER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_TECHNICALADVISER_CHECK:
      return {
        ...state,
        technicalAdvisers: state.technicalAdvisers.map(technicalAdviser =>
          technicalAdviser.id.toString() === action.payload.id.toString()
            ? { ...technicalAdviser, checked: action.payload.checked }
            : technicalAdviser
        ),
      };

    case DELETE_TECHNICALADVISER_SUCCESS:
      return {
        ...state,
        technicalAdvisers: state.technicalAdvisers.filter(
          technicalAdviser => technicalAdviser.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_TECHNICALADVISER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_TECHNICALADVISER_SUCCESS:
      return {
        ...state,
        technicalAdviser: action.payload,
      };

    case GET_TECHNICALADVISER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default technicalAdvisers;
